import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["src"]
const _hoisted_13 = { style: {"color":"white"} }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = ["onClick", "src"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 4 }
const _hoisted_22 = ["onClick", "src"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { key: 5 }
const _hoisted_25 = ["onClick", "src"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { key: 6 }
const _hoisted_28 = ["onClick", "src"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { key: 7 }
const _hoisted_31 = ["onClick", "src"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { key: 8 }
const _hoisted_34 = ["onClick", "src"]
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { key: 9 }
const _hoisted_37 = ["onClick", "src"]
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { key: 10 }
const _hoisted_40 = ["src"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { key: 11 }
const _hoisted_44 = ["src"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = ["src"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = ["src"]
const _hoisted_52 = { style: {"color":"white"} }
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = { key: 2 }
const _hoisted_55 = ["src"]
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = { class: "ml-2 mt-0 legendMapDash" }

import {
  Ref,
  computed,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
  toRaw
} from "vue";
import axios from "axios";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import MessageComponent from "@/components/SmartLink/dashboard/MessageComponent.vue";
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";
import rangeComponent from "@/components/SmartLink/dashboard/rangeComponent.vue";

/********************************
 *********** LEAFTLET ***********
 *******************************/
import {
  LMap,
  LTileLayer,
  LPolyline,
  LPopup,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
  LControl /*LHeatLayer*/,
} from "@vue-leaflet/vue-leaflet";
import "/public/leaflet/leaflet.css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.heat"; // Importamos DESPUÉS de definir window.L

/********************************
 ********** CONSTANTES **********
 *******************************/
import {
  LABELS,
  NAME_PROJECT,
  STRING_GENERAL,
  TOKEN,
} from "@/constants/labels";
import { TIMEOUTTIME } from "@/constants/apis";
import CONSTANTIMGS from "@/constants/images";
import { COLOR } from "@/constants/colors";
import CONSTMAPS from "@/constants/maps";
import CONSTAPIS from "@/constants/apis";

/********************************
 ********** INTERFACES **********
 *******************************/
import { POSITION, CIRCLE, CLUSTERING } from "@/interfaces/SmartLink/Map";
import { TOPO_ITEMS } from "@/interfaces/SmartLink/Topology";
import { EQUIPAMENTS } from "@/interfaces/SmartLink/Equips";
import { STRINGS } from "@/interfaces/SmartLink/General";
import { PointExpression } from "leaflet";

/********************************
 *********** FUNCTION ***********
 *******************************/
import {
  getStatusByLatency,
  getStatusBySNR,
  getStatusByRXLVL,
  getFinalStatusByStatitics,
} from "@/functions/maps";
import {
  getLastRXLVLandSNR,
  getAllLatencyLast,
  getAllHexagon,
} from "@/services/Smartlink/Map";
import { showConsoleError } from "@/functions/errors";


export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkChart',
  setup(__props) {

const { smAndDown, mdAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
if (typeof window !== "undefined") {
  window.L = L;
}
const pointsClustering: Ref<CLUSTERING[]> = ref([]);

const mapInstance:any = ref(null);
let heatLayer: any = null; // Aquí guardamos la capa de calor

// Esta función se dispara cuando Leaflet termina de cargar
const onMapReady = (mapObject: any) => {
  // Guardamos la instancia del mapa para usarla con Javascript puro
  mapInstance.value = mapObject;
};

const actualizarHeatmap = async () => {
  // Seguridad: Si el mapa no ha cargado, no hacemos nada
  if (!mapInstance.value) return;

  // Obtenemos el objeto 'crudo' de Leaflet (sin proxys de Vue)
  const map: any = toRaw(mapInstance.value);

  // 1. Limpiamos la capa anterior si existe
  if (heatLayer) {
    map.removeLayer(heatLayer);
  }

  const puntosCalor: any[] = [];

  // 2. Preparamos los datos: [lat, lng, intensidad]
  pointsClustering.value.forEach((p: any) => {
    if (p.latitud !== 0 && p.longitud !== 0) {
      puntosCalor.push([p.latitud, p.longitud, .3]);
    }
  });

  // 3. Creamos la capa con leaflet.heat
  heatLayer = L.heatLayer(puntosCalor, {
    radius: 17, // Radio de cada punto
    blur: 2, // Difuminado
    maxZoom: 15,
    gradient: { 0.6: "yellow", 1: "red" },
  });

  // 4. Añadimos al mapa
  map.addLayer(heatLayer);
};

// --- REACTIVIDAD ---
// Si tus datos cambian (se mueve el ScrollBar), redibujamos
watch(
  pointsClustering,
  () => {
    actualizarHeatmap();
  },
  { deep: true },
);

// Limpieza al salir
onBeforeUnmount(() => {
  if (mapInstance.value && heatLayer) {
    const map: any = toRaw(mapInstance.value);
    map.removeLayer(heatLayer);
  }
});

const active = ref(false);

const onClickOutside = () => {
  active.value = false;
};

const activeClick = () => {
  active.value = true;
};

const projectName = computed(() => store.state.projectName);

const isChile = ref(
  projectName.value === "SmartLinkAntucoya" ||
    projectName.value === "SmartLinkZaldivar",
);
const finalURL = ref("");

const width = ref("350");
const widthToolTip = ref("100");
const markerspmpsm: Ref<any[]> = ref([]);

const zoomMap = computed(() => CONSTMAPS.zoom.value);
const centerMap: Ref<PointExpression> = ref([
  CONSTMAPS.latitud.value,
  CONSTMAPS.longitud.value,
]);

const markersPMPSMwRajant: Ref<any[]> = ref([]);
const markersPMPSMwPMPAP: Ref<any[]> = ref([]);
const markersPMPAPwRajant: Ref<any[]> = ref([]);
const markersPMPAPwPMPSM: Ref<any[]> = ref([]);
const markersRajantwPMPAP: Ref<any[]> = ref([]);
const markersRajantwPMPSM: Ref<any[]> = ref([]);

const markersPMPSMwoRajant: Ref<any[]> = ref([]);
const markersPMPSMwoPMPAP: Ref<any[]> = ref([]);
const markersRajantwoPMPSM: Ref<any[]> = ref([]);
const markersRajantwoPMPAP: Ref<any[]> = ref([]);
const markersPMPAPwoRajant: Ref<any[]> = ref([]);
const markersPMPAPwoPMPSM: Ref<any[]> = ref([]);

const markersRajantwoPMPSMwoPMPAP: Ref<any[]> = ref([]);

const ipMatchPMPSMwPMPAP: Ref<string[]> = ref([]);
const ipMatchPMPSMwRajant: Ref<string[]> = ref([]);
const ipMatchRajantwPMPAP: Ref<string[]> = ref([]);

const markerspmpap: Ref<any> = ref([]);
const dialog = ref(false);
const selectedIp = ref("");
const selectedName = ref("");
const selectedType = ref("");
const elementPMPSM: Ref<EQUIPAMENTS[]> = ref([]);
const elementRAJANT: Ref<EQUIPAMENTS[]> = ref([]);
const markersrajant: Ref<any[]> = ref([]);
const toPMPAP: Ref<any> = ref({});
const polilynes: Ref<any> = ref([]);
const finalPolilynes = ref(polilynes.value);
const polilynesANY: Ref<any> = ref([]);
const finalPolilynesANY = ref(polilynesANY.value);
const finalStatus = ref("Ok");

watch(smAndDown, (valor: boolean) => {
  valor ? (width.value = "100%") : (width.value = "350");
});

const COLORSTATUS: STRINGS = {
  OK: "green",
  ALERT: "yellow",
  ALARM: "red",
  DOWN: "#353634",
};

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Format Color in Polylines
 * @param color
 */
const optionsRect = (status: string, position: POSITION[]) => {
  let color = COLORSTATUS[status];

  return {
    path: position,
    colorLine: color,
    geodesic: true,
    strokeColor: color,
    strokeOpacity: 0.8,
    strokeWeight: 3,
    fillColor: color,
    fillOpacity: 0.8,
  };
};

const matchPMPSMWithAny = async () => {
  let i = 0.00003;

  elementPMPSM.value.forEach((pmpsm: EQUIPAMENTS) => {
    i = i + 0.00003;
    const ipRaj = ref("");
    const typeRaj = ref("");
    const finalPosition = ref([0, 0]);
    const equipFindRAJ = ref(false);
    const nameRaj = ref("");
    let anotacion =
      pmpsm.anotacion !== null ? JSON.parse(pmpsm.anotacion ?? "{}") : {};
    if (anotacion.gps) {
      markersrajant.value.find(({ ip, position }) => {
        if (anotacion.gps == ip) {
          finalPosition.value = position;
        }
      });
    } else {
      if (pmpsm.latitud && pmpsm.longitud) {
        finalPosition.value = [pmpsm.latitud, pmpsm.longitud];
      }

      elementRAJANT.value.find(
        ({ name, latitud, longitud, ip, tipo }: EQUIPAMENTS) => {
          if (name && latitud && longitud) {
            let firstName = "";
            let secondName = "";

            if (
              projectName.value === NAME_PROJECT.cananea ||
              projectName.value === NAME_PROJECT.demo ||
              projectName.value === NAME_PROJECT.nacozari
            ) {
              firstName = name.split("-")[0];
              secondName = pmpsm.name?.split("M")[1] ?? "";
            }
            if (projectName.value === NAME_PROJECT.collahuasi) {
              firstName = name.split("-")[2];
              secondName = pmpsm.name?.split("-")[3] ?? "";
            }
            if (firstName === secondName) {
              equipFindRAJ.value = true;
              let finalPositions = [latitud, longitud];
              finalPosition.value = finalPositions;
              nameRaj.value = name;
              ipRaj.value = ip ?? "";
              typeRaj.value = tipo ?? "";
            }
          }
        },
      );
    }

    markerspmpsm.value.push({
      position: finalPosition.value,
      name: pmpsm.name,
      ip: pmpsm.ip,
      tipo: pmpsm.tipo,
      padre: pmpsm.padre,
      status: getStatusByIP(pmpsm.ip ?? ""),
    });

    if (equipFindRAJ.value) {
      markersPMPSMwRajant.value.push({
        position: finalPosition.value,
        nameSM: pmpsm.name,
        ipSM: pmpsm.ip,
        tipoSM: pmpsm.tipo,
        statusSM: getStatusByIP(pmpsm.ip ?? ""),
        nameRAJ: nameRaj.value,
        ipRAJ: ipRaj.value,
        tipoRAJ: typeRaj.value,
        statusRAJ: getStatusByIP(ipRaj.value ?? ""),
      });
      ipMatchPMPSMwRajant.value.push(ipRaj.value);
    } else {
      markersPMPSMwoRajant.value.push({
        position: finalPosition.value,
        name: pmpsm.name,
        ip: pmpsm.ip,
        tipo: pmpsm.tipo,
        padre: pmpsm.padre,
        status: getStatusByIP(pmpsm.ip ?? ""),
      });
    }
    let finalposition = finalPosition.value;
    const equipFindPMPAP = ref(false);

    markerspmpap.value.find(({ position, name, ip, tipo, status }: any) => {
      if (
        finalposition[0] - position[0] <= 0.0005 &&
        finalposition[0] - position[0] >= -0.0005
      ) {
        equipFindPMPAP.value = true;
        markersPMPSMwPMPAP.value.push({
          position: position,
          nameAP: name,
          ipAP: ip,
          tipoAP: tipo,
          statusAP: status,
          namePMPSM: pmpsm.name,
          ipPMPSM: pmpsm.ip,
          tipoPMPSM: pmpsm.tipo,
          statusPMPSM: getStatusByIP(pmpsm.ip ?? ""),
        });
        ipMatchPMPSMwPMPAP.value.push(pmpsm.ip ?? "");
      }
    });

    if (!equipFindPMPAP.value) {
      markersPMPSMwoPMPAP.value.push({
        position: finalPosition,
        name: pmpsm.name,
        ip: pmpsm.ip,
        tipo: pmpsm.tipo,
        status: getStatusByIP(pmpsm.ip ?? ""),
      });
    }
  });
};

const matchRajantWithAny = async () => {
  markersrajant.value.forEach((rajant: any) => {
    const equipFindPMPAP = ref(false);
    if (!ipMatchPMPSMwRajant.value.includes(rajant.ip)) {
      markersRajantwoPMPSM.value.push({
        position: rajant.position,
        name: rajant.name,
        ip: rajant.ip,
        tipo: rajant.tipo,
        status: getStatusByIP(rajant.ip ?? ""),
      });
    } else {
      markersRajantwPMPSM.value.push({
        position: rajant.position,
        name: rajant.name,
        ip: rajant.ip,
        tipo: rajant.tipo,
        status: getStatusByIP(rajant.ip ?? ""),
      });
    }

    markerspmpap.value.find(({ position, name, ip, tipo, status }: any) => {
      if (
        rajant.position[0] - position[0] <= 0.0005 &&
        rajant.position[0] - position[0] >= -0.0005
      ) {
        equipFindPMPAP.value = true;
        markersRajantwPMPAP.value.push({
          position: position,
          nameAP: name,
          ipAP: ip,
          tipoAP: tipo,
          statusAP: status,
          nameRAJ: rajant.name,
          ipRAJ: rajant.ip,
          tipoRAJ: rajant.tipo,
          statusRAJ: getStatusByIP(rajant.ip ?? ""),
        });
        ipMatchRajantwPMPAP.value.push(rajant.ip);
      }
    });
    if (!equipFindPMPAP.value) {
      markersRajantwoPMPAP.value.push({
        position: rajant.position,
        name: rajant.name,
        ip: rajant.ip,
        tipo: rajant.tipo,
        status: getStatusByIP(rajant.ip ?? ""),
      });
    }
  });
};

const matchRajantwithoutANY = async () => {
  markersRajantwoPMPSM.value.forEach((rajwosm: any) => {
    markersRajantwoPMPAP.value.find(({ ip }) => {
      if (rajwosm.ip === ip) {
        markersRajantwoPMPSMwoPMPAP.value.push(rajwosm);
      }
    });
  });
};

const matchPMPAPwithAny = async () => {
  markerspmpap.value.forEach((pmpap: any) => {
    const equipFindRajant = ref(false);

    markersrajant.value.find(({ ip, name, position, tipo, status }: any) => {
      if (
        pmpap.position[0] - position[0] <= 0.0005 &&
        pmpap.position[0] - position[0] >= -0.0005
      ) {
        equipFindRajant.value = true;
        markersPMPAPwRajant.value.push({
          position: position,
          nameRAJ: name,
          ipRAJ: ip,
          tipoRAJ: tipo,
          statusRAJ: status,
          nameAP: pmpap.name,
          ipAP: pmpap.ip,
          tipoAP: pmpap.tipo,
          statusAP: getStatusByIP(pmpap.ip ?? ""),
        });
      }
    });

    if (!equipFindRajant.value) {
      markersPMPAPwoRajant.value.push(pmpap);
    }

    markerspmpsm.value.find(({ ip, name, position, tipo }: any) => {
      if (
        pmpap.position[0] - position[0] <= 0.0005 &&
        pmpap.position[0] - position[0] >= -0.0005
      ) {
        markersPMPAPwPMPSM.value.push({
          position: position,
          nameSM: name,
          ipSM: ip,
          tipoSM: tipo,
          statusSM: getStatusByIP(ip ?? ""),
          nameAP: pmpap.name,
          ipAP: pmpap.ip,
          tipoAP: pmpap.tipo,
          statusAP: getStatusByIP(pmpap.ip ?? ""),
        });
      }
    });

    if (!ipMatchPMPSMwPMPAP.value.includes(pmpap.ip)) {
      markersPMPAPwoPMPSM.value.push(pmpap);
    }
  });
};

/**
 * Get PMPSM Data
 */
const getLatLongPMPSM = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.maps.getAllLatLngSM, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      if (
        projectName.value === NAME_PROJECT.cananea ||
        projectName.value === NAME_PROJECT.hcg ||
        projectName.value === NAME_PROJECT.demo ||
        projectName.value === NAME_PROJECT.collahuasi ||
        projectName.value === NAME_PROJECT.nacozari
      ) {
        elementPMPSM.value = response.data;
      }
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

const getAllIEOByIP = ref([{ ip: "", ok: 0, alarm: 0, alert: 0, down: 0 }]);

const getAllOperabilityLastDay = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.topology.getAllOpLastDay, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((element) => {
      getAllIEOByIP.value = element.data;
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

function getInfoInToMap(ip: string) {
  let htmlInMap = "";

  const latency = allFinalStatiticsItems.value[ip].latenciaValue;
  const rxlvl = allFinalStatiticsItems.value[ip].rxlvlValue;
  const snrh = allFinalStatiticsItems.value[ip].snrhValue;
  const snrv = allFinalStatiticsItems.value[ip].snrvValue;

  if (rxlvl && snrh && snrv) {
    htmlInMap = `
        <p>Latencia : ${latency}ms</p>
        <p>RXLVL : ${rxlvl}dBm</p>
        <p>SNRH : ${snrh}dB</p>
        <p>SNRV : ${snrv}dB</p>
        `;
  } else {
    htmlInMap = `
        <p>Latencia : ${latency}ms</p>
        `;
  }

  return htmlInMap;
}

const getColorSheet = (status: string) => {
  let colorSheet = "";
  if (status.toUpperCase() === "OK") {
    colorSheet = "green";
  }
  if (status.toUpperCase() === "ALERT") {
    colorSheet = "yellow";
  }
  if (status.toUpperCase() === "ALARM") {
    colorSheet = "red";
  }
  if (status.toUpperCase() === "DOWN") {
    colorSheet = "#505150";
  }
  return colorSheet;
};
const getColorCard = (status: string) => {
  let colorSheet = "";
  if (status.toUpperCase() === "OK") {
    colorSheet = "greenSheet";
  }
  if (status.toUpperCase() === "ALERT") {
    colorSheet = "yellowSheet";
  }
  if (status.toUpperCase() === "ALARM") {
    colorSheet = "redSheet";
  }
  if (status.toUpperCase() === "DOWN") {
    colorSheet = "greySheet";
  }
  return colorSheet;
};

const showPolilynesBoolean = ref(false);
const showTimeLineClustering = ref(false);
const showNames = ref(true);
const showClusterChBox = ref(true);
const showCircleCluster = ref(true);
const showRajant = ref(false);
const showALL = ref(true);
const showPMPSM = ref(false);
const showPMPAP = ref(false);

const showInfoMapCheckBoxes = computed(() => store.state.showInfoMap);

const showOnlyNotOk = ref(true);

const showOnlyPMPAP = ref(false);
const showOnlyPMPSM = ref(false);
const showOnlyRajant = ref(false);

const showSMandRajant = ref(true);
const showSMandAP = ref(true);
const showAPandRajant = ref(true);
const showAPandSM = ref(true);
const showRajantandAP = ref(true);
const showRajantandSM = ref(true);

const showRajantwoPMPSM = ref(true);
const showRajantwoPMPAP = ref(true);
const showPMPSMwoRajant = ref(true);
const showPMPSMwoPMPAP = ref(true);
const showRajantwoPMPSMwoPMPAP = ref(true);
const showPMPAPwoPMPSM = ref(true);
const showPMPAPwoRajant = ref(true);

const showFilters = ref(true);

const allFinalItems: any = ref({});

const getAllStatusAndLocation = async () => {
  markerspmpap.value.forEach((item: any) => {
    if (!allFinalItems.value[item.ip]) {
      allFinalItems.value[item.ip] = {};
    }
    allFinalItems.value[item.ip] = {
      position: item.position,
      status: item.status,
    };
  });

  markerspmpsm.value.forEach((item: any) => {
    if (!allFinalItems.value[item.ip]) {
      allFinalItems.value[item.ip] = {};
    }
    allFinalItems.value[item.ip] = {
      position: item.position,
      status: item.status,
    };
  });

  markersrajant.value.forEach((item: any) => {
    if (!allFinalItems.value[item.ip]) {
      allFinalItems.value[item.ip] = {};
    }
    allFinalItems.value[item.ip] = {
      position: item.position,
      status: item.status,
    };
  });
};

const allFinalStatiticsItems: any = ref({});

async function getAllRXLVLSNR() {
  const allData = await getLastRXLVLandSNR();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allData.data.forEach((item: any) => {
      if (allFinalStatiticsItems.value[item.ip]) {
        allFinalStatiticsItems.value[item.ip].snrv = getStatusBySNR(item.snrv);
        allFinalStatiticsItems.value[item.ip].snrh = getStatusBySNR(item.snrh);
        allFinalStatiticsItems.value[item.ip].rxlvl = getStatusByRXLVL(
          item.rxlvl,
        );
        allFinalStatiticsItems.value[item.ip].txlvl = getStatusByRXLVL(
          item.rxlvl,
        );
        allFinalStatiticsItems.value[item.ip].snrvValue = item.snrv;
        allFinalStatiticsItems.value[item.ip].snrhValue = item.snrh;
        allFinalStatiticsItems.value[item.ip].rxlvlValue = item.rxlvl;
      }
    });
  }
}

async function getAllFinalLatency() {
  const allData = await getAllLatencyLast();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    const finalData = allData.data;

    finalData.forEach((item: any) => {
      if (!allFinalStatiticsItems.value[item.ip]) {
        allFinalStatiticsItems.value[item.ip] = {};
      }
      allFinalStatiticsItems.value[item.ip].latencia = getStatusByLatency(
        item.latencia,
      );
      allFinalStatiticsItems.value[item.ip].latenciaValue = item.latencia;
      allFinalStatiticsItems.value[item.ip].fecha = item.fecha;
    });
  }
}

const allFinalStatusItems: any = ref({});

function getStatusByIP(ip: string) {
  if (!allFinalStatusItems.value[ip]) {
    return "down";
  }
  return allFinalStatusItems.value[ip].status;
}

const getAllPolylines = async () => {
  await getAllStatusAndLocation();

  await axios
    .get(CONSTAPIS.APIS.value.maps.getAllPolylines, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((resp) => {
      let allRelations = resp.data;
      allRelations.forEach((item: any) => {
        let positionPadre = allFinalItems.value[item.ip_fuente]
          ? allFinalItems.value[item.ip_fuente].position
          : [0, 0];
        let positionHijo = allFinalItems.value[item.ip_cliente]
          ? allFinalItems.value[item.ip_cliente].position
          : [0, 0];
        let statusHijo = allFinalItems.value[item.ip_cliente]
          ? allFinalItems.value[item.ip_cliente].status
          : "down";

        let finalStatus = statusHijo;

        let finalposition = [positionPadre, positionHijo];

        polilynes.value.push(optionsRect(finalStatus, finalposition));
      });
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

const showPolylines = async (isShow: boolean, isOnlyAlert: boolean) => {
  if (!isShow) {
    finalPolilynes.value = [];
    showPMPSM.value = false;
  } else {
    let prePolylines: any[] = [];
    polilynes.value.forEach((polilyne: any) => {
      if (polilyne.colorLine) {
        if (isOnlyAlert) {
          polilyne.colorLine.toUpperCase() !== "GREEN"
            ? prePolylines.push(polilyne)
            : null;
        } else {
          prePolylines.push(polilyne);
          showPMPSM.value = true;
        }
      }
    });
    finalPolilynes.value = prePolylines;
    store.commit("setLineMapCheckBoxes", isOnlyAlert);
  }
};

const getLatLongRAJANT = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.maps.getAllLatLngRAJ, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      elementRAJANT.value = response.data;

      elementRAJANT.value.forEach((element: EQUIPAMENTS) => {
        const latitud = element.latitud;
        const longitud = element.longitud;
        let position = [latitud, longitud];

        markersrajant.value.push({
          position: position,
          label: element.name,
          name: element.name,
          ip: element.ip,
          tipo: element.tipo,
          status: getStatusByIP(element.ip ?? ""),
        });
      });
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

// const getStatusEquipment = (ipstring:string) => {
//     let finalStatusEquipment = 'ok';

//     statusMarkers.value.find(({ip,status}:any) => {
//         if(ipstring === ip) finalStatusEquipment = status
//     });

//     return finalStatusEquipment;
// }

/**
 * Get PMPAP Data
 */
const getLatLongPMPAP = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.maps.getAllLatLngAP, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      let itemsLatLng = response.data;
      itemsLatLng.forEach((element: EQUIPAMENTS) => {
        let finalLatitud = 0;
        let finalLongitud = 0;
        let finalPosition = [finalLatitud, finalLongitud];
        let equipName = element.name;
        let anotacion =
          element.anotacion !== null
            ? JSON.parse(element.anotacion ?? "{}")
            : {};
        if (anotacion.gps) {
          markersrajant.value.find(({ ip, position }) => {
            if (anotacion.gps == ip) {
              finalPosition = position;
            }
          });
        } else {
          let gps =
            element.gps !== null
              ? JSON.parse(element.gps ?? '{"latitud":0, "longitud":0}')
              : { latitud: 0, longitud: 0 };
          finalLatitud = gps.latitud;
          finalLongitud = gps.longitud;
          if (
            element.name?.includes(STRING_GENERAL.PMPAP1) ||
            element.name?.includes(STRING_GENERAL.PMPAP5)
          ) {
            (finalLatitud = element.longitud ?? 0 + 0.000512),
              (finalLongitud = element.latitud ?? 0 - 0.000512);
          }
          finalPosition = [finalLatitud, finalLongitud];

          if (element.ip !== undefined) {
            toPMPAP.value[element.ip] = finalPosition;
          }
        }

        markerspmpap.value.push({
          position: finalPosition,
          name: `${equipName}`,
          ip: element.ip,
          tipo: element.tipo,
          status: getStatusByIP(element.ip ?? ""),
        });
      });
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

const circles: Ref<any> = ref([]);
const allCircles: Ref<any[]> = ref([]);
const allCirclesFiltered: Ref<CIRCLE[]> = ref([]);
const arrayDatesCircle: Ref<string[]> = ref([]);
const modelSliderStatus: Ref<number[]> = ref([0, 12]);

watch(modelSliderStatus, (a: number[], b: number[]) => {
  if (JSON.stringify(a) !== JSON.stringify(b))
    showCircles(arrayDatesCircle.value[a[0]], arrayDatesCircle.value[b[1]]);
});

const showCircles = async (firstDate: string, lastDate: string) => {
  circles.value = [];
  allCirclesFiltered.value.forEach((circle: CIRCLE) => {
    if (
      circle.fecha &&
      new Date(circle.fecha).getTime() <= new Date(lastDate).getTime() &&
      new Date(circle.fecha).getTime() >= new Date(firstDate).getTime()
    ) {
      circles.value.push(circle);
    }
  });
};

/**
 * When click in Item, show Dialog Component
 */
const showDialog = (ip: string, type: string, name: string, status: string) => {
  dialog.value = !dialog.value;
  selectedName.value = name;
  selectedIp.value = ip;
  selectedType.value = type;
  finalStatus.value = status;
};

const closeDialog = (value: boolean) => {
  dialog.value = value;
};

const latAlarm: Ref<any> = ref([]);
const latAlert: Ref<any> = ref([]);
const totalClusteringData: Ref<CLUSTERING[]> = ref([]);
const valueSliderMap = ref(12);
const arrayDatesClustering: Ref<string[]> = ref([]);

const get12HoursByClustering = async () => {
  await axios
    .get(CONSTAPIS.APIS.value.ia.get12HourCluster, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((resp) => {
      let arrayFechas = resp.data;
      arrayFechas.forEach((item: CLUSTERING) => {
        arrayDatesClustering.value.push(item.fecha ?? "01/01/1900");
      });
      arrayDatesClustering.value.sort();
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

const getClusteringMap = async () => {
  let params = {
    fecha: arrayDatesClustering.value[0],
  };

  await axios
    .get(CONSTAPIS.APIS.value.ia.getClusterData, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((resp) => {
      totalClusteringData.value = resp.data;

      if (totalClusteringData.value.length > 0) {
        getFilterByHours(
          arrayDatesClustering.value[arrayDatesClustering.value.length - 1],
        );
        showClusterChBox.value = false;
      } else {
        showClusterChBox.value = true;
      }
    })
    .catch(function (error) {
      showConsoleError(error);
    });
};

function getFilterByHours(fechas: string) {
  let arrayTotal = totalClusteringData.value;
  let finalArray: CLUSTERING[] = [];
  arrayTotal.forEach((element: CLUSTERING) => {
    if (
      element.fecha &&
      new Date(element.fecha).getTime() == new Date(fechas).getTime()
    ) {
      finalArray.push(element);
    }
  });
  pointsClustering.value = finalArray;
  // getClusteringByHours(finalArray);
}

const getClusteringByHours = (arrayProv: CLUSTERING[]) => {
  latAlarm.value = [];
  latAlert.value = [];
  let princAlert: CLUSTERING[] = [];
  let princAlarm: CLUSTERING[] = [];

  arrayProv.forEach((item: CLUSTERING) => {
    if (item.label === 3) {
      princAlert.push(item);
      let latitud = item.latitud ?? 0;
      let longitud = item.longitud ?? 0;
      latAlert.value.push({
        position: [latitud, longitud],
      });
    }
    if (item.label === 4) {
      princAlarm.push(item);
      let latitud = item.latitud ?? 0;
      let longitud = item.longitud ?? 0;
      latAlarm.value.push({
        position: [latitud, longitud],
      });
    }
  });
};

const season = (val: number) => {
  let finalDate = arrayDatesClustering.value[val - 1];
  return finalDate;
};

const addHours = () => {
  if (valueSliderMap.value < 12) valueSliderMap.value++;
};

const deleteHours = () => {
  if (valueSliderMap.value > 1) valueSliderMap.value--;
};

const hideALL = () => {
  showOnlyPMPAP.value = false;
  showOnlyPMPSM.value = false;
  showRajantwoPMPSMwoPMPAP.value = false;
  showOnlyRajant.value = false;

  showSMandRajant.value = false;
  showRajantwoPMPSM.value = false;
  showSMandAP.value = false;
  showRajantwoPMPAP.value = false;
  showAPandRajant.value = false;
  showPMPSMwoRajant.value = false;
  showAPandSM.value = false;
  showPMPSMwoPMPAP.value = false;
  showRajantandAP.value = false;
  showPMPAPwoPMPSM.value = false;
  showRajantandSM.value = false;
  showPMPAPwoRajant.value = false;
};

const showMarkerFunction = async (showitems: string) => {
  let functOBJ = showitems === "" ? "hideALL" : showitems;

  const functionsItems: any = {
    SM: () => {
      hideALL();
      showOnlyPMPSM.value = true;
    },
    AP: () => {
      hideALL();
      showOnlyPMPAP.value = true;
    },
    RAJ: () => {
      hideALL();
      showOnlyRajant.value = true;
    },
    SMAP: () => {
      hideALL();
      showSMandAP.value = true;
      showPMPSMwoPMPAP.value = true;
      showPMPAPwoPMPSM.value = true;
    },
    APRAJ: () => {
      hideALL();
      showAPandRajant.value = true;
      showRajantwoPMPAP.value = true;
      showPMPAPwoRajant.value = true;
    },
    SMRAJ: () => {
      hideALL();
      showSMandRajant.value = true;
      showPMPSMwoRajant.value = true;
      showRajantwoPMPSM.value = true;
    },
    SMAPRAJ: () => {
      hideALL();
      showSMandRajant.value = true;
      showSMandAP.value = true;
      showPMPSMwoRajant.value = true;
      showAPandRajant.value = true;
      showPMPAPwoRajant.value = true;
      showRajantwoPMPSMwoPMPAP.value = true;
    },
    hideALL: () => {
      hideALL();
      showPolylines(true, true);
    },
  };
  functionsItems[functOBJ]();
};

async function getCheckBoxes() {
  showPMPSM.value = showInfoMapCheckBoxes.value.includes("SM");
  showPMPAP.value = showInfoMapCheckBoxes.value.includes("AP");
  showRajant.value = showInfoMapCheckBoxes.value.includes("RAJ");
}

watch(valueSliderMap, (v: number) => {
  let dateSelected = arrayDatesClustering.value[v - 1];
  getFilterByHours(dateSelected);
});

watch(showRajant, (getBoolean: boolean) => {
  let getRaj = getBoolean ? "RAJ" : "";
  let getSM = showPMPSM.value ? "SM" : "";
  let getAP = showPMPAP.value ? "AP" : "";

  let finalObj = `${getSM}${getAP}${getRaj}`;
  store.commit("setInfoMapCheckBoxes", finalObj);
  showMarkerFunction(finalObj);
});
watch(showPMPSM, (getBoolean: boolean) => {
  let getRaj = showRajant.value ? "RAJ" : "";
  let getSM = getBoolean ? "SM" : "";
  let getAP = showPMPAP.value ? "AP" : "";

  let finalObj = `${getSM}${getAP}${getRaj}`;
  store.commit("setInfoMapCheckBoxes", finalObj);
  showMarkerFunction(finalObj);
});

watch(showPMPAP, (getBoolean: boolean) => {
  let getRaj = showRajant.value ? "RAJ" : "";
  let getSM = showPMPSM.value ? "SM" : "";
  let getAP = getBoolean ? "AP" : "";

  let finalObj = `${getSM}${getAP}${getRaj}`;
  store.commit("setInfoMapCheckBoxes", finalObj);
  showMarkerFunction(finalObj);
});

watch(showOnlyNotOk, (getBoolean: boolean) => {
  showRajant.value = !getBoolean;
  showPMPSM.value = !getBoolean;
  showPMPAP.value = !getBoolean;
  showPolilynesBoolean.value = !getBoolean;
  showPolylines(true, getBoolean);
});

const changezoom = (e: number) => {
  store.commit("setProjectZOOM", e);
};

const changeCenter = (center: any) => {
  store.commit("setProjectLAT", center.lat);
  store.commit("setProjectLNG", center.lng);
};

async function resetAllInfo() {
  markerspmpsm.value = [];
  markerspmpap.value = [];
  markersrajant.value = [];
  markersPMPSMwRajant.value = [];
  markersPMPSMwoRajant.value = [];
  markersPMPSMwPMPAP.value = [];
  markersPMPSMwoPMPAP.value = [];
  markersRajantwPMPSM.value = [];
  markersRajantwoPMPSM.value = [];
  markersRajantwPMPAP.value = [];
  markersRajantwoPMPAP.value = [];
  markersPMPAPwRajant.value = [];
  markersPMPAPwoRajant.value = [];
  markersPMPAPwPMPSM.value = [];
  markersPMPAPwoPMPSM.value = [];
  polilynes.value = [];
  finalPolilynes.value = [];
  allFinalStatiticsItems.value = {};
  allFinalStatusItems.value = {};
  toPMPAP.value = {};
  circles.value = [];
  allCircles.value = [];
  allCirclesFiltered.value = [];
  arrayDatesCircle.value = [];
  latAlarm.value = [];
  latAlert.value = [];
}

async function getAllInfo() {
  await getAllFinalLatency();
  await getAllRXLVLSNR();
  allFinalStatusItems.value = await getFinalStatusByStatitics(
    allFinalStatiticsItems.value,
  );
  await getAllOperabilityLastDay();
  await getLatLongRAJANT();
  await getLatLongPMPAP();
  await getLatLongPMPSM();
  await matchPMPSMWithAny();
  await matchRajantWithAny();
  await matchRajantwithoutANY();
  await matchPMPAPwithAny();
  await showMarkerFunction(showInfoMapCheckBoxes.value);
  await getCheckBoxes();
  await getAllPolylines();
  await showPolylines(true, true);
}

let geoJsonLayer: any = null;

async function getInfoHexagonInMap() {

  const allData:any = await getAllHexagon()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
      const finalData = allData.data;
      geoJsonLayer = L.geoJSON(finalData, {
        style: (feature: any) => ({
          color: 'white',
          weight: 1,
          fillColor: feature.properties.color,
          fillOpacity: 0.6,
        }),
        onEachFeature: (feature: any, layer: any) => {
          const p = feature.properties;
          const popupContent = `
            <div style="text-align:center">
              <h3 style="margin:0; color:${p.color}">Zona ${p.tasaFallo} Fallo</h3>
              <hr style="margin:5px 0">
              <b>Muestras:</b> ${p.muestras}<br>
              <b>Fallos:</b> ${p.fallos}<br>
            </div>`;
          layer.bindPopup(popupContent);
        },
      });

      // La añadimos al mapa por defecto
      geoJsonLayer.addTo(mapInstance.value);
    }
   
}

watch(showCircleCluster,(value:boolean) => {
  if(geoJsonLayer){
    if(value){
      geoJsonLayer.addTo(mapInstance.value);
    } else {
      mapInstance.value.removeLayer(geoJsonLayer);
    }
  }
});

let intervaloId: any = null;

async function iniciarVista() {
  if(inView.value){
    intervaloId = setInterval(async () => {
      await resetAllInfo();
      await getAllInfo();
      allFinalStatusItems.value = await getFinalStatusByStatitics(
        allFinalStatiticsItems.value,
      );
    }, 60000);
  }
}

async function cambiarDeVista() {
  if (intervaloId) {
    clearInterval(intervaloId);
    intervaloId = null;
  }
}

const inView = ref(false)

onMounted(async () => {
  
  getInfoHexagonInMap();
  inView.value = true
  finalURL.value =
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
  await getAllInfo();
  await iniciarVista();
});

onBeforeUnmount(() => {
  inView.value = false
  cambiarDeVista();
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      class: "cardDashboard",
      color: "transparent"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "ma-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              style: _normalizeStyle(`${
          _unref(mdAndDown) ? 'width: 100%' : `width: calc(100% - ${width.value}px);`
        }`)
            }, [
              (showTimeLineClustering.value)
                ? (_openBlock(), _createBlock(_component_v_slider, {
                    key: 0,
                    modelValue: valueSliderMap.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueSliderMap).value = $event)),
                    max: 12,
                    min: 1,
                    step: 1,
                    "thumb-label": "always",
                    class: "mt-6",
                    "append-icon": "mdi-plus",
                    "prepend-icon": "mdi-minus",
                    "onClick:append": addHours,
                    "onClick:prepend": deleteHours
                  }, {
                    "thumb-label": _withCtx(({ modelValue }) => [
                      _createVNode(_component_v_sheet, {
                        color: "transparent",
                        width: "150"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(season(modelValue)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "mapContainer",
                style: `height:750px `,
                onClick: activeClick
              }, [
                _createVNode(_unref(LMap), {
                  ref: "mapRef",
                  class: "mapClassBorder",
                  style: _normalizeStyle(
              !active.value ? 'border: 0px solid white' : 'border: 4px solid white'
            ),
                  zoom: zoomMap.value,
                  center: centerMap.value,
                  "onUpdate:zoom": _cache[10] || (_cache[10] = ($event: any) => (changezoom($event))),
                  "onUpdate:center": _cache[11] || (_cache[11] = ($event: any) => (changeCenter($event))),
                  onReady: onMapReady,
                  options: { zoomControl: false }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(LControlZoom), { position: 'topleft' }),
                    _createVNode(_unref(LControl), { position: "topright" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_menu, {
                          "close-on-content-click": false,
                          location: "end"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_sheet, { class: "iconMapButton" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  color: "black",
                                  variant: "text",
                                  icon: "mdi-menu"
                                }, props), null, 16)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, {
                              width: "300",
                              "max-height": "550",
                              color: "bgtopology",
                              class: "datepickerContainer"
                            }, {
                              default: _withCtx(() => [
                                (!isChile.value)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      class: "ma-2 mb-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          class: "pa-0",
                                          cols: "12",
                                          sm: "4",
                                          md: "12"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "rowIcon pl-2 pt-0",
                                                  color: "transparent",
                                                  height: "40",
                                                  width: "40"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      class: "sheetNameIcon pb-1",
                                                      width: "25",
                                                      height: "25"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          size: "small",
                                                          color: "white"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                            _createTextVNode(_toDisplayString("mdi-eye"), -1)
                                                          ]))]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_sheet, {
                                                  color: "transparent",
                                                  height: "40",
                                                  class: "rowName"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showAll")), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: showALL.value,
                                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showALL).value = $event)),
                                                  color: "success",
                                                  "hide-details": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            (showALL.value)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            height: '25',
                                                            src: _unref(CONSTANTIMGS).IMAGES.onlyap
                                                          }, null, 8, _hoisted_2)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showPMPAP")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showPMPAP.value,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showPMPAP).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            height: '25',
                                                            src: _unref(CONSTANTIMGS).IMAGES.onlypmp
                                                          }, null, 8, _hoisted_3)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showPMPSM")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showPMPSM.value,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showPMPSM).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            height: '25',
                                                            src: _unref(CONSTANTIMGS).IMAGES.onlysolar
                                                          }, null, 8, _hoisted_4)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.ShowRajant")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showRajant.value,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showRajant).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            height: '25',
                                                            src: _unref(CONSTANTIMGS).ICONS.links
                                                          }, null, 8, _hoisted_5)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showLink")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showPolilynesBoolean.value,
                                                        "onUpdate:modelValue": [
                                                          _cache[5] || (_cache[5] = ($event: any) => ((showPolilynesBoolean).value = $event)),
                                                          _cache[6] || (_cache[6] = ($event: any) => (
                              showPolylines(showPolilynesBoolean.value, false)
                            ))
                                                        ],
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon pl-2 pt-0",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_sheet, {
                                                            class: "sheetNameIcon",
                                                            width: "25",
                                                            height: "25"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                              _createElementVNode("span", { class: "nameClassIcon" }, "N", -1)
                                                            ]))]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showNames")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showNames.value,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showNames).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "rowIcon",
                                                  color: "transparent",
                                                  height: "40",
                                                  width: "40"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                      height: '25',
                                                      src: _unref(CONSTANTIMGS).ICONS.circles
                                                    }, null, 8, _hoisted_6)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_sheet, {
                                                  color: "transparent",
                                                  height: "40",
                                                  class: "rowName"
                                                }, {
                                                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                    _createElementVNode("span", null, "Clusters", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: showCircleCluster.value,
                                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showCircleCluster).value = $event)),
                                                  color: "success",
                                                  "hide-details": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_row, {
                                      key: 1,
                                      class: "ma-0 mb-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          class: "pa-0",
                                          cols: "12",
                                          sm: "4",
                                          md: "12"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: showNames.value,
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showNames).value = $event)),
                                              color: "success",
                                              label: _unref(t)('checkBoxes.showNames'),
                                              "hide-details": ""
                                            }, null, 8, ["modelValue", "label"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(LTileLayer), { url: finalURL.value }, null, 8, ["url"]),
                    (showALL.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalPolilynesANY.value, (item, i) => {
                            return (_openBlock(), _createBlock(_unref(LPolyline), {
                              key: i,
                              "lat-lngs": item.path,
                              color: item.colorLine
                            }, null, 8, ["lat-lngs", "color"]))
                          }), 128)),
                          _createElementVNode("span", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalPolilynes.value, (item, i) => {
                              return (_openBlock(), _createBlock(_unref(LPolyline), {
                                key: i,
                                "lat-lngs": item.path,
                                color: item.colorLine
                              }, null, 8, ["lat-lngs", "color"]))
                            }), 128)),
                            (showOnlyPMPSM.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markerspmpsm.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    ),
                                      "lat-lng": m.position ?? [0, 0]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlypmp
                                                }, null, 8, _hoisted_9),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_10)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "lat-lng"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showOnlyPMPAP.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markerspmpap.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    ),
                                      "lat-lng": m.position ?? [0, 0]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlyap
                                                }, null, 8, _hoisted_12),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", _hoisted_13, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_14)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "lat-lng"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showOnlyRajant.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersrajant.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    ),
                                      "lat-lng": m.position ?? [0, 0]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlysolar
                                                }, null, 8, _hoisted_16),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_17)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "lat-lng"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showRajantwoPMPSM.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersRajantwoPMPSM.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0],
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  onClick: ($event: any) => (
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          ),
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlysolar
                                                }, null, 8, _hoisted_19),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_20)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showPMPSMwoRajant.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersPMPSMwoRajant.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0],
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  onClick: ($event: any) => (
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          ),
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlypmp
                                                }, null, 8, _hoisted_22),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_23)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showPMPAPwoRajant.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersPMPAPwoRajant.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0],
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  onClick: ($event: any) => (
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          ),
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlyap
                                                }, null, 8, _hoisted_25),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_26)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showPMPAPwoPMPSM.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersPMPAPwoPMPSM.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0],
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  onClick: ($event: any) => (
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          ),
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlyap
                                                }, null, 8, _hoisted_28),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_29)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showPMPSMwoPMPAP.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersPMPSMwoPMPAP.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0],
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  onClick: ($event: any) => (
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          ),
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlypmp
                                                }, null, 8, _hoisted_31),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_32)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showRajantwoPMPSMwoPMPAP.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersRajantwoPMPSMwoPMPAP.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0],
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  onClick: ($event: any) => (
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          ),
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlysolar
                                                }, null, 8, _hoisted_34),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_35)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showRajantwoPMPAP.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersRajantwoPMPAP.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0],
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  onClick: ($event: any) => (
                            showDialog(
                              m.ip ?? '',
                              m.tipo ?? '',
                              m.name ?? '',
                              m.status ?? '',
                            )
                          ),
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlysolar
                                                }, null, 8, _hoisted_37),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_38)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showSMandRajant.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersPMPSMwRajant.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.solarsm
                                                }, null, 8, _hoisted_40),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' +
                            getColorCard(m.statusSM ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 1,
                                                      class: _normalizeClass(
                            'mt-1 classnameIcon ' +
                            getColorCard(m.statusRAJ ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.nameRAJ), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.statusSM?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'left',
                        offset: [-35, -10],
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.statusSM ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameSM), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ipSM ?? '')
                                                        }, null, 8, _hoisted_41)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        (m.statusRAJ?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 1,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                        offset: [30, -10],
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.statusRAJ ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameRAJ), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ipRAJ ?? '')
                                                        }, null, 8, _hoisted_42)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        _createVNode(_unref(LPopup), { options: { offset: [0, -35] } }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              class: "namePopUP",
                                              width: "100",
                                              color: "transparent",
                                              onClick: ($event: any) => (
                          showDialog(
                            m.ipSM ?? '',
                            m.tipoSM ?? '',
                            m.nameSM ?? '',
                            m.statusSM ?? '',
                          )
                        )
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(m.nameSM), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_v_sheet, {
                                              class: "mt-2 namePopUP",
                                              width: "100",
                                              color: "transparent",
                                              onClick: ($event: any) => (
                          showDialog(
                            m.ipRAJ ?? '',
                            m.tipoRAJ ?? '',
                            m.nameRAJ ?? '',
                            m.statusRAJ ?? '',
                          )
                        )
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(m.nameRAJ), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (showAPandRajant.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersRajantwPMPAP.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      "lat-lng": m.position ?? [0, 0]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.apsolar
                                                }, null, 8, _hoisted_44),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' +
                            getColorCard(m.statusAP ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.nameAP), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 1,
                                                      class: _normalizeClass(
                            'mt-1 classnameIcon ' +
                            getColorCard(m.statusRAJ ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", null, _toDisplayString(m.nameRAJ), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.statusAP?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'left',
                        offset: [-35, -10],
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.statusAP ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameAP), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ipAP ?? '')
                                                        }, null, 8, _hoisted_45)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        (m.statusRAJ?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 1,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                        offset: [30, -10],
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.statusRAJ ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.nameRAJ), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ipRAJ ?? '')
                                                        }, null, 8, _hoisted_46)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        _createVNode(_unref(LPopup), { options: { offset: [0, -35] } }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              class: "namePopUP",
                                              width: "100",
                                              color: "transparent",
                                              onClick: ($event: any) => (
                          showDialog(
                            m.ipAP ?? '',
                            m.tipoAP ?? '',
                            m.nameAP ?? '',
                            m.statusAP ?? '',
                          )
                        )
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(m.nameAP), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_v_sheet, {
                                              class: "mt-2 namePopUP",
                                              width: "100",
                                              color: "transparent",
                                              onClick: ($event: any) => (
                          showDialog(
                            m.ipRAJ ?? '',
                            m.tipoRAJ ?? '',
                            m.nameRAJ ?? '',
                            m.statusRAJ ?? '',
                          )
                        )
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(m.nameRAJ), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["lat-lng"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalPolilynes.value, (item, i) => {
                              return (_openBlock(), _createBlock(_unref(LPolyline), {
                                key: i,
                                "lat-lngs": item.path,
                                color: item.colorLine
                              }, null, 8, ["lat-lngs", "color"]))
                            }), 128)),
                            (!showPMPSM.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markerspmpsm.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    ),
                                      "lat-lng": m.position ?? [0, 0]
                                    }, {
                                      default: _withCtx(() => [
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LIcon), {
                                              key: 0,
                                              iconSize: [60, 60],
                                              iconAnchor: [35, 30]
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  color: "transparent",
                                                  width: 70,
                                                  class: "text-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                      height: '30',
                                                      src: _unref(CONSTANTIMGS).IMAGES.onlypmp
                                                    }, null, 8, _hoisted_48),
                                                    (showNames.value)
                                                      ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                          key: 0,
                                                          class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["class"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 1,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_49)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "lat-lng"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (!showPMPAP.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markerspmpap.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    ),
                                      "lat-lng": m.position ?? [0, 0]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LIcon), {
                                          iconSize: [60, 60],
                                          iconAnchor: [35, 30]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_sheet, {
                                              color: "transparent",
                                              width: 70,
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  height: '30',
                                                  src: _unref(CONSTANTIMGS).IMAGES.onlyap
                                                }, null, 8, _hoisted_51),
                                                (showNames.value)
                                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                      key: 0,
                                                      class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h5", _hoisted_52, _toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 0,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_53)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "lat-lng"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (!showRajant.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersrajant.value, (m, index) => {
                                    return (_openBlock(), _createBlock(_unref(LMarker), {
                                      key: index,
                                      onClick: ($event: any) => (
                      showDialog(
                        m.ip ?? '',
                        m.tipo ?? '',
                        m.name ?? '',
                        m.status ?? '',
                      )
                    ),
                                      "lat-lng": m.position ?? [0, 0]
                                    }, {
                                      default: _withCtx(() => [
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LIcon), {
                                              key: 0,
                                              iconSize: [60, 60],
                                              iconAnchor: [35, 30]
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  color: "transparent",
                                                  width: 70,
                                                  class: "text-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                      height: '30',
                                                      src: _unref(CONSTANTIMGS).IMAGES.onlysolar
                                                    }, null, 8, _hoisted_55),
                                                    (showNames.value)
                                                      ? (_openBlock(), _createBlock(_component_v_sheet, {
                                                          key: 0,
                                                          class: _normalizeClass(
                            'classnameIcon ' + getColorCard(m.status ?? 'down')
                          )
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["class"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        (m.status?.toUpperCase() !== 'OK')
                                          ? (_openBlock(), _createBlock(_unref(LTooltip), {
                                              key: 1,
                                              options: {
                        permanent: false,
                        interactive: true,
                        direction: 'right',
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "sheetTooltip text-center",
                                                  color: "#9fa09f",
                                                  "min-width": widthToolTip.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      color: getColorSheet(m.status ?? 'down')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(m.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"]),
                                                    _createVNode(_component_v_row, {
                                                      class: "ma-0",
                                                      style: {"align-items":"center"},
                                                      justify: "center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          innerHTML: getInfoInToMap(m.ip ?? '')
                                                        }, null, 8, _hoisted_56)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["min-width"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "lat-lng"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["style", "zoom", "center"]),
                (!active.value)
                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                      key: 0,
                      class: "mapTest"
                    }))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_click_outside, { handler: onClickOutside }]
              ]),
              _createVNode(_component_v_sheet, {
                class: "mt-5",
                width: "100%",
                color: "transparent",
                style: {"align-content":"center"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    class: "ma-0",
                    justify: _unref(smAndDown) ? 'center' : 'space-between'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        color: "transparent",
                        width: _unref(mdAndDown) ? '100%' : 360
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            class: "ma-0",
                            justify: _unref(mdAndDown) ? 'center' : 'start'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode(" mdi-speedometer ", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_57, [
                                _createTextVNode(_toDisplayString(_unref(t)("labels.latency")) + " | ", 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)("labels.redSpeed")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["justify"])
                        ]),
                        _: 1
                      }, 8, ["width"]),
                      _createVNode(rangeComponent, {
                        class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
                        "principal-color": _unref(COLOR).green,
                        "secundary-color": 'rgb(62 97 57)',
                        "color-text-princ": 'white',
                        "color-text-secun": 'white',
                        "principal-text": _unref(t)('labels.ok'),
                        "secundary-text": '0 a 100 ms',
                        sheetWidth: _unref(smAndDown) ? 350 : 225
                      }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"]),
                      _createVNode(rangeComponent, {
                        class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
                        "principal-color": _unref(COLOR).yellow,
                        "secundary-color": '#B4A343',
                        "color-text-princ": 'black',
                        "color-text-secun": 'white',
                        "principal-text": _unref(t)('labels.alert'),
                        "secundary-text": '100 a 500 ms',
                        sheetWidth: _unref(smAndDown) ? 350 : 225
                      }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"]),
                      _createVNode(rangeComponent, {
                        class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
                        "principal-color": _unref(COLOR).red,
                        "secundary-color": '#8F3A36',
                        "color-text-princ": 'white',
                        "color-text-secun": 'white',
                        "principal-text": _unref(t)('labels.alarm'),
                        "secundary-text": 'Mayor a 500 ms',
                        sheetWidth: _unref(smAndDown) ? 350 : 225
                      }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"])
                    ]),
                    _: 1
                  }, 8, ["justify"])
                ]),
                _: 1
              })
            ], 4),
            (showFilters.value)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  color: "transparent",
                  class: _normalizeClass(_unref(mdAndDown) ? 'pa-0 pt-4' : 'pl-4'),
                  style: _normalizeStyle(_unref(mdAndDown) ? 'text-align: -webkit-center;' : ''),
                  width: _unref(mdAndDown) ? '100%' : width.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(MessageComponent)
                  ]),
                  _: 1
                }, 8, ["class", "style", "width"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialog).value = $event)),
      width: "85%"
    }, {
      default: _withCtx(() => [
        (dialog.value)
          ? (_openBlock(), _createBlock(DialogComponent, {
              key: 0,
              ip: selectedIp.value,
              typeSel: selectedType.value,
              name: selectedName.value,
              status: finalStatus.value,
              onDialog: closeDialog
            }, null, 8, ["ip", "typeSel", "name", "status"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})